export default __webpack_public_path__ + "static/media/480_dummy2016-pragentur01-de-mobile.68a22752.png";